import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-plum text-cream mt-24 grain" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="inline-block rounded-2xl bg-white/95 px-4 py-3">
            <Logo />
          </div>
          <p className="mt-4 text-rose-soft/80 text-[15px] leading-relaxed max-w-xs">
            A supportive circle for women 45+ getting stronger, moving better and aging well—together.
          </p>
        </div>
        <div>
          <h2 className="text-rose font-display text-lg mb-4">Community</h2>
          <ul className="space-y-2.5 text-[15px] text-cream/80">
            <li><Link to="/community" className="hover:text-rose transition-colors">All Discussions</Link></li>
            <li><Link to="/community/strength-and-muscle" className="hover:text-rose transition-colors">Strength & Muscle</Link></li>
            <li><Link to="/community/menopause-and-fitness" className="hover:text-rose transition-colors">Menopause & Fitness</Link></li>
            <li><Link to="/community/start-again" className="hover:text-rose transition-colors">Start Again</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="text-rose font-display text-lg mb-4">Explore</h2>
          <ul className="space-y-2.5 text-[15px] text-cream/80">
            <li><Link to="/guides" className="hover:text-rose transition-colors">Guides & Resources</Link></li>
            <li><Link to="/glossary" className="hover:text-rose transition-colors">Fitness Glossary</Link></li>
            <li><Link to="/challenges" className="hover:text-rose transition-colors">Challenges</Link></li>
            <li><Link to="/newsletter" className="hover:text-rose transition-colors">StrongKind Weekly</Link></li>
            <li><Link to="/join" className="hover:text-rose transition-colors">Join the Circle</Link></li>
          </ul>
        </div>
        <div>
          <h2 className="text-rose font-display text-lg mb-4">A note on trust</h2>
          <p className="text-[14px] text-cream/70 leading-relaxed">
            We're a founding community. We never invent members, reviews or numbers.
            Nothing here is medical advice—please consult a professional for your health.
          </p>
        </div>
      </div>
      <div className="border-t border-rose/20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-6 flex flex-col sm:flex-row justify-between gap-3 text-[13px] text-cream/60">
          <span>© {new Date().getFullYear()} StrongKind Circle. Made with care.</span>
          <span>strongkindcircle.com</span>
        </div>
      </div>
    </footer>
  );
}
